import {
  CONTACT_LIST,
  CONTACT_LIST_PAGINATION,
  CREATE_CONTACT,
  DELETE_CONTACT,
  EDIT_CONTACT,
  IMPORT_CONTACT_DATA,
  POSITION_LIST,
} from "./apiRoutes";
import { authData } from "./Service";

export const listOfContactApi = async (data) => {
  const response = await authData.post(CONTACT_LIST, data);
  return response?.data;
};

export const listOfContactsApi = async (data) => {
  const response = await authData.post(CONTACT_LIST_PAGINATION, data);
  return response?.data;
};

export const CreateContactApi = async (data) => {
  const response = await authData.post(CREATE_CONTACT, data);
  return response?.data;
};

export const EditContactApi = async (data) => {
  const response = await authData.put(EDIT_CONTACT, data);
  return response?.data;
};

export const DeleteContactApi = async (id) => {
  const response = await authData.delete(`${DELETE_CONTACT}${id}`);
  return response?.data;
};

export const listOfSalesPosition = async (data) => {
  const response = await authData.post(POSITION_LIST, data);
  return response?.data;
};

export const importContactData = async (data) => {
  const response = await authData.get(IMPORT_CONTACT_DATA, data);
  return response?.data;
};
